var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"map",attrs:{"id":"container"}}),_c('p',{staticClass:"MapTime"},[_vm._v(_vm._s(_vm.$t('lang.particulars.ProcessDate'))+":"+_vm._s(_vm.UpdateTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }